'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { useEffect, useRef } from 'react';

export function useTrackOnce(track: () => void, enabled = true): void {
  const trackRef = useRef(track);
  const hasTrackedRef = useRef(false);

  trackRef.current = track;

  useEffect(() => {
    if (!enabled || hasTrackedRef.current) return;
    hasTrackedRef.current = true;
    trackRef.current();
  }, [enabled]);
}
